export default "__VITE_ASSET__DkmrSPzX__"